<div class="modal__header modal__header--alert">
	<h2 class="title" id="modal__title">E-mail já registado</h2>
	<div class="modal__header-actions">
		<button aria-label="Close dialog" (click)="closeModal()">
			<app-svg svg="icons.svg#general--close" aria-hidden="true" [alt]="'Close icon'"></app-svg>
		</button>
	</div>
</div>
<div class="modal__body sl--scrollable">
	Este e-mail já está associado a uma conta.<br>
	Faça login ou crie uma nova conta TAP Miles&Go
</div>
<!-- <div class="modal__body sl--scrollable">
	Start a new search and try registering again in 10 minutes.<br>
	<a class="link" (click)="TAP_newSearch()" href="javascript:;" role="button">New Search</a>
</div> -->
<!-- <div class="modal__footer">
	<div class="modal__footer-action"><button class="button" (click)="TAP_goWithoutDiscount()">Continue without discount</button></div>
</div> -->
<div class="modal__footer">
			<div class="modal__footer-action negative-action footerActionSize"><button class="button button--small buttonModal">Recover password</button></div>
				<div class="modal__footer-action positive-action footerActionSize"><button class="button button--small buttonModal"
					(click)="TAP_handleLoginClick()">Login</button>
			 </div>
</div>
<div class="login-footer">
    I want to creat a <a class="link" href="javascript:void();" (click)="TAP_handleSignUp()">new account</a>
</div>


